import { useState } from "react";
import "./AffiliateCenter.css";
import AffiliateProfile from "./AffiliateProfile";
import AffiliateMemberProfile from "./AffiliateMemberProfile";
import AffiliateCoupon from "./AffiliateCoupon";
import Wallet from "./Wallet";
import { useNavigate } from "react-router-dom";

export default function AffiliateMember() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [showProfile, setShowProfile] = useState(true);

  const handleShowMembers = () => {
    setShowProfile(false);    
  }

  return (
    <>
      <div className="ac_navbar_container">
        <div className="ac_navbar">
          <div
            className={`ac_navbar_options ${activeTab === 1 ? "active_tab" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            My Affiliate Profile
          </div>
          <div
            className={`ac_navbar_options ${activeTab === 2 ? "active_tab" : ""}`}
            onClick={() => setActiveTab(2)}
          >
            Affilliate Coupon Codes
          </div>
          <div
            className={`ac_navbar_options ${activeTab === 3 ? "active_tab" : ""}`}
            onClick={() => setActiveTab(3)}
          >
            Wallet
          </div>
        </div>
        <button className="ac_back_btn" onClick={() => navigate(-1)}>
          <img src="/build/img/Icons/down_vector.svg" alt="Back" style={{transform: 'rotate(90deg)', marginRight: '8px'}} width={12} height={12} />
          Back
        </button>
      </div>
      <div className="ac_member_layout">
        {activeTab === 1 ? (
         showProfile ? (
          <AffiliateProfile onShowMembers={handleShowMembers} />
        ) : (
          <AffiliateMemberProfile />
        )
        ) : activeTab === 2 ? (
          <AffiliateCoupon />
        ) : (
          <Wallet />
        )}
      </div>
    </>
  );
}
